/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerBulkRetryIngestionsMutationResponse, DocumentUseCasesControllerBulkRetryIngestions400, DocumentUseCasesControllerBulkRetryIngestions401, DocumentUseCasesControllerBulkRetryIngestions403 } from "../../models/documentUseCasesController/DocumentUseCasesControllerBulkRetryIngestions";

function getDocumentUseCasesControllerBulkRetryIngestionsUrl() {
  const res = { method: 'POST', url: `/api/v1/documents/ingestions/bulk-retry` as const }  
  return res
}

/**
 * @description Admin/service-account maintenance endpoint. Finds document processings that are FAILED/CANCELLED or appear stuck (RUNNING/RUNNABLE/PENDING/FAILING beyond a threshold) within a lookback window, then enqueues ingestion jobs. The ingestion job preCheck will route to reprocessing when appropriate.
 * @summary Bulk retry document ingestion for failed/stuck processings
 * {@link /api/v1/documents/ingestions/bulk-retry}
 */
export async function documentUseCasesControllerBulkRetryIngestions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentUseCasesControllerBulkRetryIngestionsMutationResponse, ResponseErrorConfig<DocumentUseCasesControllerBulkRetryIngestions400 | DocumentUseCasesControllerBulkRetryIngestions401 | DocumentUseCasesControllerBulkRetryIngestions403>, unknown>({ method : "POST", url : getDocumentUseCasesControllerBulkRetryIngestionsUrl().url.toString(), ... requestConfig })  
  return res.data
}